import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AppLayout } from '@/layouts/AppLayout';
import { HomePage } from '@/features/home/pages/HomePage';
import { LoginPage, RegisterPage, ProfilePage } from '@/features/auth';
import {
  ProductsPage,
  ProductDetailPage,
  TcgCardsPage,
  TcgCardDetailPage,
  CartPage,
  WompiReturnPage,
  OrderConfirmationPage,
  OrdersListPage,
  OrderDetailPage,
  SellerOrdersPage,
  SellerProductsPage,
  AdminOrdersPage,
} from '@/features/catalog';
import { ProtectedRoute } from '@/components';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        path: 'register',
        element: <RegisterPage />,
      },
      {
        path: 'profile',
        element: (
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'products',
        element: <ProductsPage />,
      },
      {
        path: 'products/:id',
        element: <ProductDetailPage />,
      },
      {
        path: 'tcg',
        element: <TcgCardsPage />,
      },
      {
        path: 'yugioh',
        element: <TcgCardsPage />,
      },
      {
        path: 'tcg/cards/:id',
        element: <TcgCardDetailPage />,
      },
      {
        path: 'yugioh/cards/:id',
        element: <TcgCardDetailPage />,
      },
      {
        path: 'cart',
        element: (
          <ProtectedRoute>
            <CartPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'order-confirmation/:orderId',
        element: (
          <ProtectedRoute>
            <OrderConfirmationPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'payment/wompi/return',
        element: (
          <ProtectedRoute>
            <WompiReturnPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'orders',
        element: (
          <ProtectedRoute>
            <OrdersListPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'orders/:orderId',
        element: (
          <ProtectedRoute>
            <OrderDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'seller/products',
        element: (
          <ProtectedRoute>
            <SellerProductsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'seller/orders',
        element: (
          <ProtectedRoute>
            <SellerOrdersPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/orders',
        element: (
          <ProtectedRoute requireAdmin>
            <AdminOrdersPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);

export function AppRouter(): JSX.Element {
  return <RouterProvider router={router} />;
}
